import React, { useContext, useEffect, useState } from 'react'
import { Card, Col, Divider, List, Row, Tag, Typography } from 'antd'
import useHideMenu from '../hooks/useHideMenu';
import { SocketContext } from '../context/SocketContext';
import { getLastTickets } from '../helpers/getLastTickets';

const { Title, Text } = Typography

const Tail = () => {

    const { socket } = useContext(SocketContext)
    const [ tickets, setTickets ] = useState([])
    useHideMenu(true)

    useEffect(() => {
        socket.on('assigned-tickets', (assignedTickets) => {
            setTickets(assignedTickets)
        })

        return () => {
            socket.off('assigned-tickets')
        }
    }, [ socket ])

    useEffect(() => {
        getLastTickets()
            .then(tickets => setTickets(tickets))
    }, [])


    return (
        <>
            <Title level={1}>Assisting client</Title>
            <Row>
                <Col span={12} >
                    <List
                        split={false}
                        dataSource={tickets.slice(0, 3)}
                        renderItem={item => (
                            <List.Item>
                                <Card
                                    style={{ width: 300, marginTop: 14 }}
                                    actions={[
                                        <Tag color="volcano">{item.agent}</Tag>,
                                        <Tag color="magenta">Desk: {item.desk}</Tag>
                                    ]}
                                >
                                    <Title level={2}>No. {item.number}</Title>
                                </Card>
                            </List.Item>
                        )}
                    />
                </Col>

                <Col span={12} >
                    <Divider> History </Divider>

                    <List
                        dataSource={tickets.slice(3)}
                        renderItem={item => (
                            <List.Item.Meta
                                style={{ marginTop: 24 }}
                                title={`Ticket No. ${item.number}`}
                                description={
                                    <>
                                        <Text type="secondary">On desk: </Text>
                                        <Tag color="magenta" style={{ marginRight: 20 }}>{item.desk}</Tag>
                                        <Text type="secondary">Agent: </Text>
                                        <Tag color="volcano">{item.agent}</Tag>
                                    </>
                                }
                            />
                        )}
                    />
                </Col>
            </Row>
        </>
    )
}

export default Tail